import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from '@phosphor-icons/react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <div className="flex items-center justify-center px-4 py-20">
        <Card className="w-full max-w-md p-8 neumorphism rounded-2xl text-center" data-testid="payment-cancel">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle size={48} className="text-red-600" weight="fill" />
          </div>
          <h2 className="font-heading font-semibold text-3xl mb-4">Pagamento Annullato</h2>
          <p className="text-foreground/70 mb-8">
            Il pagamento è stato annullato. Nessun addebito è stato effettuato.
          </p>
          <div className="flex gap-4">
            <Button
              variant="outline"
              onClick={() => navigate(-1)}
              className="flex-1 rounded-full"
              data-testid="go-back-btn"
            >
              Torna Indietro
            </Button>
            <Button
              onClick={() => navigate('/dashboard')}
              className="flex-1 rounded-full"
              data-testid="go-to-dashboard-btn"
            >
              Dashboard
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PaymentCancel;